import React, { useCallback } from 'react'
import Loader from 'components/Loader'
import usePortfolios from 'hooks/models/usePortfolios'
import useSnackbar from 'hooks/useSnackbar'
import PortfolioForm from './PortfolioForm'

export default function EditPortfolio({ portfolio, onSave, isAdminOrOwner }) {
  const { openSnackbar } = useSnackbar()
  const {
    updatePortfolio: { mutation: updatePortfolio, isLoading: isUpdatingPortfolio },
  } = usePortfolios()

  const initialValues = {
    name: portfolio.name || '',
    location: portfolio.location || '',
    description: portfolio.description || '',
    isCounterparty: portfolio.isCounterparty ?? false,
  }

  const handleSubmit = useCallback(
    async (values, { setSubmitting }) => {
      const editedPortfolio = {
        id: portfolio.id,
        ...values,
      }
      try {
        const result = await updatePortfolio(editedPortfolio)
        setSubmitting(false)
        if (result.error) {
          throw result.error
        }
        openSnackbar({
          message: `Portfolio saved successfully`,
          color: 'success',
        })
        onSave()
      } catch (error) {
        openSnackbar({
          message: `Failed to save portfolio, please try again or contact support`,
          color: 'error',
        })
      }
    },
    [portfolio.id, updatePortfolio, openSnackbar, onSave]
  )

  return (
    <>
      {!isUpdatingPortfolio && <Loader />}
      <PortfolioForm
        initialValues={initialValues}
        onSubmit={handleSubmit}
        isSubmitDisabled={isUpdatingPortfolio}
        isCreate={false}
        disabled={!isAdminOrOwner}
      />
    </>
  )
}
